/**
 * Frases do FinOps que dependem de contagem.
 *
 * "sugestão" tem plural irregular: a frase inteira é escolhida, nunca montada com
 * sufixos — colar "ões" em "sugestão" foi o que pôs "sugestãoões" na tela (14/10/2026).
 */
export function textoDoResultadoDaIa(quantidade: number): string {
  if (quantidade === 0) {
    return 'A IA concluiu a análise, mas não encontrou nenhuma sugestão nova desta vez.'
  }
  return quantidade === 1
    ? '1 sugestão nova gerada pela IA.'
    : `${quantidade} sugestões novas geradas pela IA.`
}
